export default __webpack_public_path__ + "425c0f11c6991ff5908191fc4a87964f.png";